import {StyleSheet} from 'react-native';

import {variants} from '/component/base/Text/Text.style';
import {indent} from '/constant/layout.constant';
import {
  black,
  cloudLight,
  cloudLighter,
  onyx,
  onyxLightest,
} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  container: {
    paddingLeft: 0,
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: indent / 2,
  },
  heading: {
    flex: 1,
    ...variants.large,
    ...getFontFamily('bold'),
    color: onyx,
    fontSize: 16,
  },
  metric: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: indent * 0.85,
    marginHorizontal: 0,
  },
  scrollBody: {
    width: '100%',
  },
  scrollContent: {
    paddingBottom: indent / 2,
  },
  body: {
    flex: 1,
    minWidth: 0,
  },
  metricTitle: {
    ...variants.small,
    ...getFontFamily('bold'),
    color: onyx,
    fontSize: 13,
  },
  metricSubhead: {
    ...variants.small,
    ...getFontFamily('regular'),
    color: onyxLightest,
    marginTop: 2,
    fontSize: 13,
  },
  closeIcon: {
    fontSize: 18,
    color: black,
  },
  iconContainer: {
    marginRight: 6,
    alignSelf: 'center',
    height: 30,
    width: 30,
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: cloudLighter,
    cursor: 'pointer',
  },
  icon: {
    fontSize: 32,
    color: onyx,
    paddingTop: indent / 6,
    marginRight: indent * 1.2,
  },
  bulletPoints: {
    ...variants.small,
    ...getFontFamily('regular'),
    marginTop: indent / 2,
    marginLeft: 0,
    color: onyxLightest,
    maxWidth: 520,
    fontSize: 13,
  },
  divider: {
    height: 1,
    backgroundColor: cloudLight,
    marginTop: indent / 4,
    marginBottom: indent / 3,
  },
});
